import type { ProductKindEnum as DmProductKindEnum } from '@iheartjane/dm-sdk';
import { ProductKindEnum } from '@iheartjane/types';

export const parseKindFromStaticFilters = (
  staticFilters?: string
): Array<{ kind: DmProductKindEnum[] }> | undefined => {
  const matchedKind = staticFilters?.match(/root_types:['"]([^'"]+)['"]/)?.[1];
  const kind = ProductKindEnum.find((k) => k === matchedKind);
  return kind !== undefined
    ? [{ kind: [kind as DmProductKindEnum] }]
    : undefined;
};
